import { memo } from 'react'
import Modal from '@/components/interface/Modal/Modal'
import * as styles from './ModalBuyersGuide.module.scss'
/**
 * The `ModalBuyersGuide`
 * @returns {React.ReactElement} the element
 */
function ModalBuyersGuide () {
  return (
    <Modal.Container>
      <Modal.Header>Buyers Guide</Modal.Header>
      <Modal.Body>
        <div className={styles.content}>
          <p>
            To buy the $TIGERSHARK token you need to have a wallet on the solana
            network and some of the SOL token. Here is the simplest way to get
            Tiger Shark tokens.
          </p>
          <ul>
            <li>
              Step 1 – Visit the Phantom Wallet website and get yourself a
              phantom wallet -{' '}
              <a
                href="https://phantom.com/en-GB"
                target="_blank"
                rel="noreferrer"
              >
                https://phantom.com/en-GB
              </a>
              <br />
              <br />
              <strong>Watch this video guide for setting up Phantom Wallet:</strong>
              <br />
              <iframe
                width="100%"
                height="200"
                src="https://www.youtube.com/embed/c_FhRbHqlTc"
                title="Phantom Wallet Setup Guide"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                style={{ marginTop: '10px', maxWidth: '100%', borderRadius: '8px' }}
               />
            </li>
            <li>
              Once you have your wallet set up purchase SOL directly in the app
              – Follow this guide to do so -{' '}
              <a
                href="https://help.phantom.com/hc/en-us/articles/4406543783571-How-to-buy-Solana-SOL-Ethereum-ETH-Polygon-POL-BASE-SUI-and-Bitcoin-BTC"
                target="_blank"
                rel="noreferrer"
              >
                https://help.phantom.com/hc/en-us/articles/4406543783571-How-to-buy-Solana-SOL-Ethereum-ETH-Polygon-POL-BASE-SUI-and-Bitcoin-BTC
              </a>
            </li>
            <li>
              Swap your new Solana for the Tiger Shark token. The Token address
              is: <code>YXUpFaULqhrLJS79JmFtAsNZQ2JDTnPemmdVZEFpump</code>
              <br />
              You will need this to find the token in phantom. Here is a guide
              to using the swap feature.{' '}
              <a
                href="https://help.phantom.com/hc/en-us/articles/6048249796243-Phantom-Swapper-FAQ"
                target="_blank"
                rel="noreferrer"
              >
                https://help.phantom.com/hc/en-us/articles/6048249796243-Phantom-Swapper-FAQ
              </a>
            </li>
          </ul>
        </div>
      </Modal.Body>
    </Modal.Container>
  )
}

export default memo(ModalBuyersGuide)
